import jsPDF from "jspdf";
import autoTable, { type RowInput } from "jspdf-autotable";
import {
	buildInvoiceAndReturnsExportFileName,
	formatInvoiceAndReturnsAmount,
	invoiceAndReturnsExportHeaders,
	type InvoiceAndReturnsExportParams,
	prepareInvoiceAndReturnsExportData
} from "./invoiceAndReturnsExportData";

import { pdfTypeCell } from "./invoiceAndReturnsExportData";

export const exportInvoiceAndReturnsToPdf = ({
	ledgerEntries,
	startDate,
	endDate
}: InvoiceAndReturnsExportParams) => {
	const { rows, totals } = prepareInvoiceAndReturnsExportData(ledgerEntries);

	const doc = new jsPDF({
		orientation: "landscape",
		unit: "pt",
		format: "a4"
	});

	doc.setFont("helvetica", "bold");
	doc.setFontSize(16);
	doc.text("Invoice Returns and Payment Report", 40, 40);

	doc.setFont("helvetica", "normal");
	doc.setFontSize(10);
	doc.text(`Date range: ${startDate} to ${endDate}`, 40, 58);

	const body: RowInput[] = rows.map((row) => [
		row.invoiceNumber,
		row.date,
		pdfTypeCell(row.type),
		row.customer,
		formatInvoiceAndReturnsAmount(row.amount),
		formatInvoiceAndReturnsAmount(row.cash),
		formatInvoiceAndReturnsAmount(row.upi),
		formatInvoiceAndReturnsAmount(row.outstanding),
		formatInvoiceAndReturnsAmount(row.profit)
	]);

	autoTable(doc, {
		startY: 78,
		head: [invoiceAndReturnsExportHeaders],
		body,
		foot: [
			[
				{
					content: "Total",
					colSpan: 4,
					styles: { halign: "right", fontStyle: "bold" }
				},
				formatInvoiceAndReturnsAmount(totals.amount),
				formatInvoiceAndReturnsAmount(totals.cash),
				formatInvoiceAndReturnsAmount(totals.upi),
				formatInvoiceAndReturnsAmount(totals.outstanding),
				formatInvoiceAndReturnsAmount(totals.profit)
			]
		],
		showFoot: "lastPage",
		theme: "grid",
		styles: {
			font: "helvetica",
			fontSize: 8,
			cellPadding: 4,
			overflow: "linebreak",
			lineColor: [220, 220, 220],
			lineWidth: 0.5
		},
		headStyles: {
			fillColor: [242, 242, 242],
			textColor: [20, 20, 20],
			fontStyle: "bold"
		},
		footStyles: {
			fillColor: [242, 242, 242],
			textColor: [20, 20, 20],
			fontStyle: "bold"
		},
		columnStyles: {
			0: { cellWidth: 82 },
			1: { cellWidth: 62 },
			2: { cellWidth: 56 },
			3: { cellWidth: 140 },
			4: { halign: "right", cellWidth: 82 },
			5: { halign: "right", cellWidth: 62 },
			6: { halign: "right", cellWidth: 62 },
			7: { halign: "right", cellWidth: 82 },
			8: { halign: "right", cellWidth: 62 }
		},
		margin: { top: 40, right: 40, bottom: 40, left: 40 }
	});

	const pageCount = doc.getNumberOfPages();
	for (let page = 1; page <= pageCount; page += 1) {
		doc.setPage(page);
		doc.setFont("helvetica", "normal");
		doc.setFontSize(8);
		doc.text(
			`Page ${page} of ${pageCount}`,
			doc.internal.pageSize.getWidth() - 40,
			doc.internal.pageSize.getHeight() - 20,
			{ align: "right" }
		);
	}

	doc.save(buildInvoiceAndReturnsExportFileName(startDate, endDate, "pdf"));
};
